import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiMutationHook } from '../../../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../../../common/queryClient/getMutationFn';
import { UserFollowedDataObjectGroupUrl } from './UserFollowedDataObjectGroupUrl';

import { UserFollowedDataObjectGroupSchema } from '../schema/UserFollowedDataObjectGroupSchema';
import {
  UserFollowedDataObjectGroupFormDataType,
  UserFollowedDataObjectGroupValidFormDataType,
} from '../schema/types';

const postUserFollowedDataObjectGroup = (
  userFollowedDataObjectGroup: UserFollowedDataObjectGroupValidFormDataType,
  headers?: HttpHeaders,
) =>
  apiClient
    .post<UserFollowedDataObjectGroupFormDataType>(
      expand(UserFollowedDataObjectGroupUrl.base, {}),
      UserFollowedDataObjectGroupSchema.parseMutationDto(
        userFollowedDataObjectGroup,
      ),
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

const deleteUserFollowedDataObjectGroup = (id: number) =>
  apiClient
    .delete<void>(expand(UserFollowedDataObjectGroupUrl.base, { id }))
    .then((response) => response.data);

export const useMutateUserFollowedDataObjectGroupQuery = createApiMutationHook(
  ['userFollowedDataObjectGroup'],
  getMutationFn(
    postUserFollowedDataObjectGroup,
    undefined,
    deleteUserFollowedDataObjectGroup,
  ),
);
